import { AgentRegister } from '../../models/agents/agent-register';
import { InvestorRepresentative } from '../../models/agents/investor-representative';

export class RegisterIsCadastralUpdate {
  readonly type = 'REGISTER_IS_CADASTRAL_UPDATE';
  constructor(public isCadastralUpdate: boolean) {}
}

export class UpdateInvestorRepresentative {
  readonly type = 'UPDATE_INVESTOR_REPRESENTATIVE';
  constructor(public investorRepresentative: InvestorRepresentative) {}
}

export class UpdateInvestorRepresentativeOnServer {
  readonly type = 'UPDATE_INVESTOR_REPRESENTATIVE_SERVER';
  constructor(public investorRepresentative: InvestorRepresentative) {}
}

export class AddAgent {
  readonly type = 'ADD_AGENT';
  constructor(public agent: AgentRegister) {}
}

export type Actions =
  | RegisterIsCadastralUpdate
  | UpdateInvestorRepresentative
  | UpdateInvestorRepresentativeOnServer
  | AddAgent;
